var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-field-wrapper ui-field-select-wrapper"},[_c('app-field-label',{attrs:{"forAttribute":_vm.componentId,"text":_vm.localLabel}}),_c('b-form-select',{class:{placeholder: !_vm.localValue},attrs:{"id":_vm.componentId,"value":_vm.localValue,"options":_vm.options},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }